export class ChatUser {
	constructor(
		public id: number,
		public userId: number,
		public name: string,
		public online: boolean = false,
		public color: string = '#35CD96'
	) {}
}
